<template>
  <div id="combat_knockout" v-show="currThemeObj">
    <template v-if="!isNotDataFlag">
      <COMBAT_DYNAMICDENDRIFORM_KNOCKOUT
        :datas="{
          data: {
            dataList: teamListGroup,
          },
        }"
        :currThemeObj="currThemeObj"
        themeContainerWidthStr="100vw - 2 * 9.722vw"
        :sportType="sportType"
        :currCid="currCid"
        @publicThemeFromChildEvent="formatThemeActJson"
        :sportCompetitionType="sportCompetitionType"
      ></COMBAT_DYNAMICDENDRIFORM_KNOCKOUT>
    </template>
    <cup_notData
      v-if="isNotDataFlag && teamListGroup && teamListGroup.length === 0"
      :className="'relativePtb30'"
    ></cup_notData>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import cup_notData from '@components/base/NO_DATA.vue'
import COMBAT_DYNAMICDENDRIFORM_KNOCKOUT from '@components/compreSportsMeet/html/HTML_KNOCKOUT/combat_dynamicDendriform.vue'
export default {
  name: 'combat_knockout',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    cup_notData,
    COMBAT_DYNAMICDENDRIFORM_KNOCKOUT,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    datas: {
      type: Array,
      default: () => {
        return []
      },
    },
    sportType: {
      type: String,
      default: '', // 'compreSportsMeet'
    },
    themeTemplateType: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('combat_knockout datas 重新刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          if (newVal && newVal.length > 0) {
            let maxColNum = 0
            newVal.forEach((groupItem) => {
              if (
                groupItem &&
                groupItem.data &&
                groupItem.data.length > 0 &&
                groupItem.data.length > maxColNum
              )
                maxColNum = groupItem.data.length
            })
            this.maxColNum = maxColNum
          }
          this.init()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isNotDataFlag: false,
      teamListGroup: null,
      numberNoWidthVw: 4.16,
      rollingLimit: 4, // 列数大于等于4时，出现横滑效果
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
    console.debug('combat_knockout:', this.datas)
  },
  methods: {
    init() {
      this.makeDatas()
      if (this.themeTemplateType) {
        this.makeAnalysisItemParams(this.themeTemplateType)
      }
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: this.sportType,
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      console.debug('resData:', resData)
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          // console.debug(`aa: ${item}`)
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
        this.shareDataAddThemeItem(this.themeItem)
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    shareDataAddThemeItem(themeItem) {
      if (!this.isNotDataFlag && this.teamListGroup.length > 0 && themeItem) {
        console.debug('this.teamListGroup 1:', this.teamListGroup)
        this.teamListGroup = this.teamListGroup.map((orginTableItem) => {
          const groupTitle = themeItem.analysisItemName
          const CSMeetSportsEventNames = this.currSportsDetail.sportsName
            ? `${this.currSportsDetail.sportsName} ${this.currSportsDetail.eventName}-`
            : ''
          let singleTableTheme = {
            analysisItemId: themeItem.analysisItemId,
            // title: `${this.currSportsDetail.sportsName} · ${this.currSportsDetail.eventName}-${orginTableItem.bracket1Name}${groupTitle}`,
            title: `${CSMeetSportsEventNames}${orginTableItem.bracket1Name}${groupTitle}`,
          }
          return Object.assign(orginTableItem, singleTableTheme)
        })
        console.debug('this.teamListGroup:', this.teamListGroup)
      }
    },
    formatThemeActJson(table) {
      if (!this.themeItem) return
      // 主题不同，有些地方需要特殊处理
      // 传参组id
      let keyArrActJson = []
      let newThemeItem = JSON.parse(JSON.stringify(this.themeItem))
      newThemeItem.sportsId = newThemeItem.disciplineId
      newThemeItem.title = table.title
      newThemeItem.sportsId = this.currSportsDetail.sportsId
      newThemeItem.eventId = this.currSportsDetail.eventId
      newThemeItem.actJson = JSON.parse(newThemeItem.json)
      keyArrActJson = Object.keys(newThemeItem.actJson)
      keyArrActJson.forEach((keyItem) => {
        newThemeItem.actJson[keyItem] = table[keyItem]
      })
      console.debug('newThemeItem:', newThemeItem, table, this.teamListGroup)
      this.clickPublicTheme(newThemeItem)
    },
    clickPublicTheme(themeItem) {
      // 分享主题
      let newThemeItem = themeItem
      console.debug('newThemeItem:', newThemeItem)
      // 需要加【篮球-预赛B组积分榜】
      newThemeItem.analysisItemName = newThemeItem.title
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
      })
    },
    computedPadding(initHeightVw, initSpace, index) {
      // initSpace 值的就是 .matchItem 中的 margin-bottom 值
      // [(8.4*0+1.2*0)/2,(8.4*1+1.2*0)/2,(8.4*2+1.2*1)/2,(8.4*4+1.2*3)/2,(8.4*8+1.2*7)/2,...]
      let paddingTop =
        (initHeightVw * (index === 0 ? index : Math.pow(2, index - 1)) +
          initSpace *
            (index === 0
              ? index
              : Math.pow(2, index - 1) === 0
              ? Math.pow(2, index - 1)
              : Math.pow(2, index - 1) - 1)) /
        2

      return paddingTop
    },
    computedHeight(initHeightVw, initSpace, index) {
      // [(8.4*1+1.2*0),(8.4*1+1.2*1),(8.4*2+1.2*2),(8.4*4+1.2*4),(8.4*8+1.2*8),...]
      let height =
        initHeightVw * (index === 0 ? 1 : Math.pow(2, index - 1)) +
        initSpace * (index === 0 ? index : Math.pow(2, index - 1))

      return height
    },
    computedColumnWidth(index, group, rollingLimt, numberNoWidthVw) {
      // 大于等于rollingLimt值时，100%展示3列半；否则就按照 maxColNum 的列数渲染
      let columnLength = this.maxColNum
      if (this.maxColNum >= rollingLimt) {
        columnLength = 3.5
      }

      let columnWidthVw =
        index === 0
          ? `calc((100vw - 9.722vw - 9.722vw - ${numberNoWidthVw}vw) / ${columnLength} + ${numberNoWidthVw}vw)`
          : `calc((100vw - 9.722vw - 9.722vw - ${numberNoWidthVw}vw) / ${columnLength})`
      return columnWidthVw
    },
    computedTotalColumnWidth(group, rollingLimt, numberNoWidthVw) {
      let columnLength = this.maxColNum
      if (this.maxColNum >= rollingLimt) {
        columnLength = 3.5
      }
      return `calc(((100vw - 9.722vw - 9.722vw - ${numberNoWidthVw}vw) / ${columnLength}) * ${group.length} + ${numberNoWidthVw}vw)`
    },
    makeDatas() {
      if (this.datas && this.datas.length > 0) {
        this.isNotDataFlag = false
      } else {
        if (this.datas) {
          this.isNotDataFlag = true
        }
        this.teamListGroup = []
      }
      if (!this.isNotDataFlag) {
        this.teamListGroup = this.datas
      }
      console.debug('datas 1:', this.datas)
    },
    _valNameFormatHandler(val, state) {
      // 处理是显示名字还是待定还是轮空
      if (state === 'NOCOMP') {
        return '-'
      } else if (!state) {
        return '待定'
      } else {
        return val
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    // goDetail(routerName, item, id) {
    //   console.debug(
    //     routerName,
    //     item,
    //     this.isBroadCastList,
    //     this.sportType,
    //     this.currCid
    //   )
    //   if (this.isBroadCastList || (!item && !id)) return
    //   let query = {}
    //   let sportRouterBase = ''
    //   if (this.sportType === 'compreSportsMeet') {
    //     sportRouterBase = 'CSMeet'
    //   } else if (this.sportType === 'tennis') {
    //     sportRouterBase = 'tennis'
    //   }
    //   if (routerName == `${sportRouterBase}PlayerDetailIndex`) {
    //     query.playerId = item ? item.player_id : id
    //   }
    //   if (routerName == `${sportRouterBase}DelegationDetailIndex`) {
    //     query.delegationId = item ? item.team_id : id
    //   }
    //   if (routerName == `${sportRouterBase}SportDetailScheduleDetail`) {
    //     query = {
    //       cid: this.currCid,
    //       sid: this.currSid,
    //       sportsId: item.sportsId,
    //       eventId: item.eventId,
    //       mid: item.mid,
    //     }
    //   }
    //   this.openNewWeb(this.$router, `${routerName}_${this.currCid}`, query)
    // },
  },
}
</script>

<style lang="scss" scoped>
#combat_knockout {
  padding-bottom: 2.778vw;
}
</style>
